module.exports = __webpack_public_path__ + "static/media/dice-6.1376f600.png";